import React from 'react';
import { useIntl } from 'react-intl';

import {
  Wrapper,
  Chart,
  ChartWrapper,
  Row,
  Name,
  TimelineRow,
  Timeline,
  Year,
  LegendList,
  LegendListItem
} from './MembersTimeline.styles';

export interface MembersTimelineProps {
  className?: string;
}

const MembersTimeline = ({ className = '' }: MembersTimelineProps) => {
  const intl = useIntl();

  return (
    <Wrapper className={className}>
      <ChartWrapper>
        <Chart>
          <Row>
            <Name>{intl.formatMessage({ id: 'people.taka' })}</Name>
            <TimelineRow type="taka" />
          </Row>
          <Row>
            <Name>{intl.formatMessage({ id: 'people.toru' })}</Name>
            <TimelineRow type="toru" />
          </Row>
          <Row>
            <Name>{intl.formatMessage({ id: 'people.alex' })}</Name>
            <TimelineRow type="alex" />
          </Row>
          <Row>
            <Name>{intl.formatMessage({ id: 'people.ryota' })}</Name>
            <TimelineRow type="ryota" />
          </Row>
          <Row>
            <Name>{intl.formatMessage({ id: 'people.yu' })}</Name>
            <TimelineRow type="yu" />
          </Row>
          <Row>
            <Name>{intl.formatMessage({ id: 'people.tomoya' })}</Name>
            <TimelineRow type="tomoya" />
          </Row>
          <Timeline>
            <Year>2005</Year>
            <Year></Year>
            <Year>2007</Year>
            <Year></Year>
            <Year>2009</Year>
            <Year></Year>
            <Year>2015</Year>
            <Year></Year>
            <Year>~</Year>
            <Year></Year>
            <Year>{intl.formatMessage({ id: 'about.members.timeline.now' })}</Year>
          </Timeline>
        </Chart>
      </ChartWrapper>
      <LegendList>
        <LegendListItem type="leadVocals">{intl.formatMessage({ id: 'about.members.timeline.leadVocals' })}</LegendListItem>
        <LegendListItem type="leadGuitar">{intl.formatMessage({ id: 'about.members.timeline.leadGuitar' })}</LegendListItem>
        <LegendListItem type="bass">{intl.formatMessage({ id: 'about.members.timeline.bass' })}</LegendListItem>
        <LegendListItem type="drums">{intl.formatMessage({ id: 'about.members.timeline.drums' })}</LegendListItem>
        <LegendListItem type="addGuitars">{intl.formatMessage({ id: 'about.members.timeline.addGuitars' })}</LegendListItem>
        <LegendListItem type="rhythmGuitar">{intl.formatMessage({ id: 'about.members.timeline.rhythmGuitar' })}</LegendListItem>
        <LegendListItem type="backingVocals">{intl.formatMessage({ id: 'about.members.timeline.backingVocals' })}</LegendListItem>
      </LegendList>
    </Wrapper>
  );
};

export default MembersTimeline;
